export default "__VITE_ASSET__04ef630f__"